import React from 'react';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import moment from 'moment';
import stopped from '../images/stopped.svg';
import location from '../images/location.png';
import driving from '../images/driving.svg';
import style from '../styles/style.module.css';

const TrackingMap = ({ data, outerBounds, trackings }) => {
  const coor1 = [trackings[0], trackings[trackings.length - 1]];

  return (
    <MapContainer
      center={[0, 0]}
      bounds={outerBounds}
      style={{ width: '100%', height: '100vh' }}
    >
      <TileLayer
        noWrap={false}
        url="https://tiles.tteld.com/styles/osm-bright/{z}/{x}/{y}.png"
      />

      <Polyline pathOptions={{ fillColor: 'red' }} positions={outerBounds} />

      {coor1.length > 0 &&
        coor1.map((marker, i) => (
          <Marker
            key={`coor-${i}`}
            position={[marker?.coordinates.lat || 0, marker?.coordinates.lng || 0]}
            icon={L.divIcon({
              iconSize: [35, 35],
              iconAnchor: i === 0 ? [17, 32] : undefined,
              html:
                i === 1
                  ? `<img style="transform: rotate(${marker?.rotation}deg)" src="${driving}" alt="" />`
                  : `<img height="35" width="35" src="${location}" alt="" />`,
              className: 'iconDiv',
            })}
          >
            <Popup>
              <div className={style.IW_it}>
                <span className={style.left}>Name:</span>
                <span className={style.right}>
                  {data.driver.first_name + ' ' + data.driver.second_name}
                </span>
              </div>
              <div className={style.IW_it}>
                <span className={style.left}>Address:</span>
                <span className={style.right}>{marker?.address}</span>
              </div>
              <div className={style.IW_it}>
                <span className={style.left}>Date:</span>
                <span className={style.right}>
                  {moment(marker?.date).format('DD-MM-YYYY hh:mm:ss A')}
                </span>
              </div>
              <div className={style.IW_it}>
                <span className={style.left}>Speed:</span>
                <span className={style.right}>{marker?.speed}</span>
              </div>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${marker?.coordinates.lat}%2C${marker?.coordinates.lng}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop: '10px', display: 'inline-block' }}
              >
                View on Google Maps
              </a>
            </Popup>
          </Marker>
        ))}

      {data.stops.length > 0 &&
        data.stops.map((loc, index) => (
          <Marker
            key={`stop-${index}`}
            position={loc.coordinates}
            icon={L.icon({
              iconSize: [20, 20],
              iconUrl: stopped,
            })}
          >
            <Popup>
              <div className={style.IW_it}>
                <h3>{loc.address}</h3>
              </div>
              <div className={style.IW_it}>
                <span className={style.left}>Stopped:</span>
                <span className={style.right}>
                  {moment(loc.start_date).format('MMM DD, LT')} -{' '}
                  {moment(loc.end_date).format('LT')}
                </span>
              </div>
              <div className={style.IW_it}>
                <span className={style.left}>Duration:</span>
                <span className={style.right}>
                  {moment.utc(loc.duration * 1000).format(
                    loc.duration > 3600 ? 'hh[h] mm[m] ss[s]' : 'mm[m] ss[s]'
                  )}
                </span>
              </div>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${loc.coordinates.lat}%2C${loc.coordinates.lng}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop: '10px', display: 'inline-block' }}
              >
                View on Google Maps
              </a>
            </Popup>
          </Marker>
        ))}
    </MapContainer>
  );
};

export default TrackingMap;
